function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.7031 0.051327C17.7896 0.505384 8.73007 7.10542 5.02734 10.3487C6.18309 14.0206 8.79192 18.7586 10.4598 24.2136C12.5363 31.005 13.5786 38.5429 14.5139 41.2407C19.7842 31.7542 33.9734 24.2947 42.1627 27.7812C50.3519 31.2677 52.5411 26.9704 53.433 25.8353L53.4629 25.7971C54.394 24.6109 57.5427 20.5994 62.5952 23.7271C65.5 25.5253 71 24 72.0007 22.5109C67.1358 21.4568 64.4601 17.4838 62.352 14.7271C60.2439 11.9703 56.1087 5.15947 50.5952 7.10541C45.0816 9.05135 42.0005 6.53785 40.3789 5.15947C38.7573 3.78108 35.5951 -0.516244 25.7031 0.051327Z",
  fill: "#78CA95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6746 11.1596C29.4313 10.7542 28.3773 9.94336 27.2421 9.94336C26.107 10.1055 25.7016 11.1596 25.9448 11.565C26.1881 11.9704 26.5935 11.7272 27.4854 11.565C28.3773 11.4028 28.7016 11.9704 29.1881 12.1326C29.6746 12.2947 29.9178 11.565 29.6746 11.1596Z",
  fill: "#558F69"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1315 13.0221C41.3958 12.7084 42.1788 11.9414 43.3828 12.316C44.3328 12.6116 44.6409 13.4443 44.2703 13.8841C44.0059 14.1977 43.6923 13.9334 42.9507 13.6715C42.2091 13.4095 41.853 13.8509 41.4139 13.9226C40.9748 13.9944 40.8672 13.3358 41.1315 13.0221Z",
  fill: "#558F69"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.5241 15.8381C31.2867 15.533 30.8469 15.478 30.5418 15.7154C30.2366 15.9527 30.1816 16.3925 30.419 16.6977C31.5625 18.1679 33.6865 20.6072 37.1153 20.6974C39.985 20.7729 41.485 18.6475 41.7869 17.4063C41.8783 17.0307 41.6478 16.6521 41.2722 16.5607C40.8965 16.4693 40.5179 16.6998 40.4265 17.0754C40.242 17.8343 39.2122 19.3521 37.1521 19.2979C34.4188 19.226 32.6508 17.2868 31.5241 15.8381Z",
  fill: "#558F69"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.39648,
  y: 3.62793,
  width: 1.62163,
  height: 63.4058,
  transform: "rotate(-17 1.39648 3.62793)",
  fill: "#474354"
}), /*#__PURE__*/React.createElement("rect", {
  y: 4.05469,
  width: 4.54057,
  height: 1.62163,
  rx: 0.810816,
  transform: "rotate(-17 0 4.05469)",
  fill: "#474354"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.89282 11.7271C3.18366 11.3217 3.74017 10.2988 5.51449 10.1865",
  stroke: "#78CA95",
  strokeWidth: 0.621622
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2252 42.457C12.6264 42.073 13.0963 41.1039 14.5943 40.9976",
  stroke: "#78CA95",
  strokeWidth: 0.621622
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.5 63.1123C43.5 63.8679 47.5 64.2213 52.5 61.5771C62.3867 56.3485 67.5 74.1541 82 74.5319L80.5 84H-1V64.9572C0.833336 64.5794 6.2 59.022 11 56C17 52.2225 21 52.6465 25 53.7798C29 54.913 39.5 62.3568 41.5 63.1123Z",
  fill: "url(#paint0_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 49,
  y1: 30.7126,
  x2: 47.2533,
  y2: 75.1279,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DFDFE1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFA"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  fill: "white"
})));

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.524f6d5e.svg";
export { ForwardRef as ReactComponent };